import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import confirm from "webmodals/confirm";
import labels from "servicestack/ipa-files/_labels";

export default class DataFileContainerController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.labels = labels;
    return {
      url: "QueryIpaInfos.json",
      hideLeftNav: true, // $ctrl.$page.is('gt-sm'),
      orderBy: "-Uploaded,FileName",
      filters: [
        { date: "Uploaded", title: labels.uploaded },
        {
          number: "Size",
          title: labels.size,
          min: 0,
          max: 2000,
          step: 0.01
        }
      ],
      sortOptions: {
        FileName: "Name: A to Z",
        "-FileName": "Name: Z to A",
        "Size,FileName": labels.size,
        "-Size,FileName": labels.size,
        "BundleVersion,FileName": "Version: Latest",
        "-BundleVersion,FileName": "Version: Oldest",
        "Uploaded,FileName": labels.uploaded,
        "-Uploaded,FileName": labels.uploaded
      },
      autoLoad: true,
      pageSize: 12
    };
  }

  install(ipa) {
    console.debug("install", ipa);
    return confirm(
      `Do you want to install ${ipa.fileName}...`,
      "Are you sure?"
    ).result.then(() => (location.href = ipa.installUrl));
  }
}
